export default __webpack_public_path__ + "static/media/Watch.8d3eba6b.png";